import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { TokenStorageService } from 'src/app/core/authentication/token-storage.service';

@Component({
  selector: 'app-downloader',
  templateUrl: './downloader.component.html',
  styleUrls: ['./downloader.component.sass']
})
export class DownloaderComponent implements OnInit {
  showModal = false;

  constructor(
    private tokenStorage: TokenStorageService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.checkSession();
    // login/logout navigate elsewhere in the app instead of emitting an event, so re-check on every navigation
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.checkSession();
      }
    });
  }

  close(): void {
    this.showModal = false;
  }

  async install(): Promise<void> {
    // captured as early as possible in index.html, since the browser can fire this before Angular finishes bootstrapping
    const deferredPrompt = (window as any).deferredInstallPrompt;
    if (!deferredPrompt) {
      return;
    }
    deferredPrompt.prompt();
    await deferredPrompt.userChoice;
    (window as any).deferredInstallPrompt = null;
  }

  private checkSession(): void {
    const loggedIn = !!this.tokenStorage.getUser()?.username;
    this.showModal = !loggedIn && !this.isInstalledApp() && this.isMobileViewport();
  }

  private isInstalledApp(): boolean {
    return (
      window.matchMedia('(display-mode: standalone)').matches ||
      (window.navigator as any).standalone === true
    );
  }

  private isMobileViewport(): boolean {
    return window.matchMedia('(max-width: 767px)').matches;
  }
}
